export const FOCUS_MODULES_PARENT_ID = 'hs_focus_mode';
export const FOCUS_MODE_STYLES_CLASSNAME = 'hs-focus-mode-styles';
export const FOCUS_MODE_SUBTREE_ID = 'hs_active_focus_mode';
const FOCUS_MODE_MIN_WIDTH = 600;
export function addFocusModeStyles(node, maxWidth) {
  node.classList.add(FOCUS_MODE_STYLES_CLASSNAME);

  // To preserve WYSIWYG editing, we need to enforce guardrails on the
  // min and max widths that the editor can be within. We are applying a
  // min-width as well, so if the maxWidth argument ends up being smaller
  // than the mid-width value, we default the max-width to the mid-width
  // to avoid any issues with the max-width overriding the min-width.
  const maxWidthValue = maxWidth < FOCUS_MODE_MIN_WIDTH ? FOCUS_MODE_MIN_WIDTH : maxWidth;
  node.style.maxWidth = `${maxWidthValue}px`;
}
export function setDisplayValue(children, displayValue) {
  for (const child of children) {
    // Do not change display value for active focus mode container
    if (child.id === FOCUS_MODE_SUBTREE_ID) continue;
    if (child.nodeName === 'LINK') continue;
    // If we hit a script tag, we want to exit this function to
    // prevent nodes that exist after our HS CMS injected scripts
    // like the RTE root or UIPopovers from getting a display value
    // that could affect rendering. While this works for the KBv3 editor,
    // the order of scripts and HS UI nodes being appended to the DOM
    // is not a guarantee for all template/content types. Before enabling
    // focus mode for the developer use case, this should be tested further.
    if (child.nodeName === 'SCRIPT') return;
    if (child instanceof HTMLElement) {
      child.style.display = displayValue;
    }
  }
}
export function createSubTreeNode() {
  const node = document.createElement('div');
  node.setAttribute('id', FOCUS_MODE_SUBTREE_ID);
  node.setAttribute('data-test-id', FOCUS_MODE_SUBTREE_ID);
  return node;
}